import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkPasswordStrength } from '../../utils/textUtils';

class PasswordStrengthInput extends Component {

    constructor(props, context) {
        super(props, context);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.checkPassword = this.checkPassword.bind(this);
        this.minimumScore = 3;
        this.state = {
            strengthClass: '',
            strengthText: '',
            password: ''
        };
    }

    componentDidMount() {
        
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ password: this.props.value }, this.checkPassword);
        }
    }

    onPasswordChange(event) {
        this.setState({ password: event.target.value }, this.checkPassword);
        if(this.props.onChange) {
            //also set the password strength on the parent for validation? or can we overwrite the validation somehow?
            this.props.onChange(event);
        }
    }

    checkPassword() {
        const strength = checkPasswordStrength(this.state.password);
        const score = strength.score;
        let strengthClass = '';
        let strengthText = '';

        if (score >= 0 && score <= 1) {
            strengthClass = 'veryweak';
            strengthText = 'very weak';
        } 
        else if (score === 2) {
            strengthClass = 'weak';
            strengthText = 'weak';
        } 
        else if(score === 3){
            strengthClass = 'medium';
            strengthText = 'medium';    
        } 
        else if(score > 3) {
            strengthClass = 'strong';
            strengthText = 'strong';
        }                
        this.setState({ strengthClass, strengthText });
    }

    render() {
        return (     
            <React.Fragment>     
                <input id={this.props.id || 'password'} name={this.props.name || 'password'} type="password" className="mdl-textfield__input" minLength="8" onChange={this.onPasswordChange} value={this.state.password} required={this.props.required} />  
                <div className="strength_meter">
                    <div className={this.state.strengthClass}>{this.state.strengthText}</div>
                </div>
            </React.Fragment>  
        );
    }
}

PasswordStrengthInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    id: PropTypes.string,
    name: PropTypes.string,
    required: PropTypes.bool
};

export default PasswordStrengthInput;